import React, { useState } from "react";
import axios from "axios";
import { Box, Button, Typography, Paper, Stack, Snackbar, Alert } from "@mui/material";
import InvisibleLandlordsTable from "components/Tables/InvisibleLandlordsTable";
import { useInvisibleLandlords } from "services/hooks/rentals";

export default function InvisibleLandlords() {
   const { invisibleLandlords, isLoadingInvisibleLandlords, errorInvisibleLandlords } = useInvisibleLandlords();

  return (
    <Box m="20px">
      <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between">
        <Typography
          variant="h4"
          gutterBottom
          sx={{ fontWeight: "bold", mb: 5, fontSize: 25 }}
        >
          Invisible Landlords
        </Typography>
      </Stack>
      <Paper sx={{ marginTop: "1rem", overflow: "hidden" }}>
        <InvisibleLandlordsTable
         data={invisibleLandlords}
        />
      </Paper>
    </Box>
  );
}